import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import { startUpdates } from "./updates.js";
import "./index.css";

const el = document.getElementById("root");
if (!el) throw new Error("#root is missing from index.html");
createRoot(el).render(
  <StrictMode>
    <App />
  </StrictMode>
);

// Check for a new build on load, on focus, and every ten minutes.
startUpdates();
